import { Button, ButtonGroup } from '@blueprintjs/core';
import React, { useContext, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PageHeader } from '../../../../components';
import { AnalyticsContext, OrganisationContext } from '../../../../context';
import { useQuery } from '../../../../hooks';
import { DATASOURCE_QUERY_DOCUMENT_MANIFEST } from '../../../../queries';
import DocumentManifestGridView from './gridView';
import styles from './styles.module.css';

const DocumentManifestReport = ({ insight, onExport }: any) => {
  const { t } = useTranslation();
  const organisation = useContext(OrganisationContext);
  const analytics = useContext(AnalyticsContext);
  const [view, setView] = useState<'detail' | 'summary'>('detail');

  const { loading, data, error } = useQuery(DATASOURCE_QUERY_DOCUMENT_MANIFEST, {
    selector: 'queryDocumentManifest.result',
    variables: {
      organisationKey: organisation.key,
      reportId: insight.id,
    },
  });

  const actions = useMemo(() => {
    if (insight.exportType) {
      return [
        {
          ...insight.exportButtonProps,
          onClick: () => {
            analytics.events.insights.exportViewClicked();
            return onExport();
          },
        },
      ];
    }
    return [];
  }, [insight, analytics, onExport]);

  if (loading) {
    return <div>{t('Loading...')}</div>;
  }

  if (error) {
    return <div>{t('Unknown Error Occurred')}</div>;
  }

  return (
    <div className={styles.layout}>
      <PageHeader noWrapper={false} actions={actions} />
      <div className={styles.toolbar}>
        <ButtonGroup>
          <Button
            active={view === 'detail'}
            onClick={() => setView('detail')}
            text={t('All Documents')}
          />
          <Button
            active={view === 'summary'}
            onClick={() => setView('summary')}
            text={t('Summary by Location')}
          />
        </ButtonGroup>
      </div>
      <div className={styles.gridArea}>
        <DocumentManifestGridView rows={data || []} view={view} />
      </div>
    </div>
  );
};

export default DocumentManifestReport;
